import AttorneyAssignments from './AttorneyAssignments';

export default AttorneyAssignments;
